import { extendTheme } from "@chakra-ui/react";

const theme = extendTheme({
  fonts: {
    heading: "Prompt, sans-serif",
    body: "Prompt, sans-serif",
  },
});

export default theme;
